<template>
    <div>
        <b-modal
            id="checkInModal"
            ref="checkInModal"
            :scrollable="true"
            :lazy="true"
            @hidden="close"
            :title="title"
            title-tag="h2"
            no-close-on-backdrop
        >
            <transition name="slide-fade">
                <appointment
                    ref="appointment"
                    v-if="page == 'appointment'"
                    :data="appointment_data"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="pl-2"
                />
                <bundle
                    ref="bundle"
                    v-if="page == 'bundle'"
                    :data="bundle_data"
                    :app-data="appointment_data"
                    :isEstimate="isEstimate"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="px-1"
                />
            </transition>
            <div slot="modal-footer" class="w-100">
                <b-btn
                    @click="$refs.checkInModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-btn
                >
                <div v-if="loading" class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                </div>
                <div v-else class="float-right">
                    <b-btn
                        @click="back"
                        v-if="page != 'appointment'"
                        variant="primary"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        @click="save"
                        v-if="
                            (isBundle || isAdmit || page == 'bundle') &&
                            !isStartTreatment
                        "
                        :disabled="
                            page == 'bundle' &&
                            bundle_data.selectedElements.length === 0
                        "
                        variant="primary"
                        >Save</b-btn
                    >
                    <b-btn
                        @click="save"
                        v-else-if="isStartTreatment"
                        variant="primary"
                        >Save + Start Treatment</b-btn
                    >
                    <b-btn @click="next" v-else variant="primary">Next</b-btn>
                </div>
            </div>
        </b-modal>
        <multipleRequisitionForm ref="multipleRequisitionFormWindow" />
        <!-- <idexxSubmit ref="modalIdexxSubmit" /> -->
        <notifications group="check-in" width="324px">
            <template slot="body" slot-scope="props">
                <div class="vue-notification-template vue-notification">
                    <div class="notification-title">
                        {{ props.item.title }}
                        <a @click="props.close" class="close">&times;</a>
                    </div>
                    <div class="notification-content">
                        <ol>
                            <li
                                v-for="client in notification.client"
                                :key="client.id"
                            >
                                {{ client.content }}
                            </li>
                            <li
                                v-for="patient in notification.patient"
                                :key="patient.id"
                            >
                                {{ patient.content }}
                            </li>
                        </ol>
                    </div>
                </div>
            </template>
        </notifications>
        <StartTreatment ref="startTreatment" />
    </div>
</template>
<script>
import StartTreatment from "@/module/schedule/treatment-board/start";
import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
import Appointment from "./check-in.vue";
import Bundle from "@/module/commons/bundle/bundle";
import moment from "moment";
import ScheduleHelper from "@/module/schedule/helper";
import CensusMixin from "@/mixins/census";

export default {
    components: {
        Appointment,
        Bundle,
        MultipleRequisitionForm,
        StartTreatment
        // IdexxSubmit
    },
    mixins: [ScheduleHelper, CensusMixin],
    props: {
        instanceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            page: "appointment",
            loading: false,
            open_time: null,
            appointment_data: {
                id: null,
                start: null,
                end: null,
                client: null,
                client_id: null,
                reason: "",
                patient: null,
                patient_id: null,
                note: "",
                staff_id: null,
                soap_id: null,
                type: 1,
                repeat: 1,
                referrer: null,
                referrer_id: null,
                occurence: 1,
                location: null,
                appointmentType: null,
                status_id: 1,
                letter_ids: [],
                webforms: [],
                bundle_id: [],
                single_bundle_id: "",
                bill_to_invoice: -3,
                print_card: false,
                print_quantity: 1,
                weight: 0,
                uom: 75,
                admit: false,
                isDefaultProvider: false,
                author_id: null,
                mobileCountryCode: null,
                mobile: null,
                communicationType: 0,
                isUpdateClientContact: false,
                triage_id: null,
                triage_type_id: null,
                startTreatment: false
            },
            bundle_data: {
                bundle_id: null,
                selectedElements: [],
                elements: []
            },
            start_treatment_data: {
                patient: {},
                treatment: {},
                clientID: "",
                treatmentID: ""
            },
            title: "Check In",
            notification: {
                client: [],
                patient: []
            }
        };
    },
    computed: {
        isBundle() {
            if (this.appointment_data.admit) {
                return !this.appointment_data.single_bundle_id;
            } else {
                if (this.appointment_data.bundle_id.length > 0) {
                    return false;
                }

                return true;
            }
        },
        isAdmit() {
            return this.appointment_data.admit;
        },
        isEstimate() {
            return (
                this.appointment_data.bill_to_invoice &&
                (this.appointment_data.bill_to_invoice == -2 ||
                    this.appointment_data.bill_to_invoice.type === -2)
            );
        },
        hasNotification() {
            return (
                this.notification.patient.length ||
                this.notification.client.length
            );
        },
        isStartTreatment() {
            return this.isAdmit && this.appointment_data.startTreatment;
        }
    },
    watch: {
        "appointment_data.client_id"(value) {
            this.notification.client = [];
            if (value) {
                this.clientNotes(value);
            }
        },
        "appointment_data.patient_id"(newValue, oldValue) {
            this.notification.patient = [];
            if (newValue && !oldValue && this.appointment_data.note) {
                this.appointment_data.note += "\n";
            } else if (newValue && oldValue) {
                this.appointment_data.note = "";
            }
            if (newValue && this.appointment_data.patient_changed) {
                this.patientNotes(newValue);
            }
        },
        hasNotification(value) {
            if (value) {
                this.popupNotification();
            } else {
                this.$notify({
                    group: "check-in",
                    clean: true
                });
            }
        }
    },
    created() {
        let self = this;
        this.$on("change-page", page => {
            self.page = page;
        });
    },
    methods: {
        popupNotification() {
            this.$notify({
                group: "check-in",
                clean: true
            });
            if (
                this.notification.client.length ||
                this.notification.patient.length
            ) {
                this.$notify({
                    group: "check-in",
                    title: "ATTENTION",
                    duration: -1,
                    closeOnClick: false
                });
            }
        },
        patientNotes(id) {
            let self = this;
            return self.$http
                .get(process.env.BARRACUDA + "patient/" + id + "/popup-notes")
                .then(function (response) {
                    self.notification.patient = response.data.response.resource;
                });
        },
        clientNotes(id) {
            let self = this;
            return self.$http
                .get(
                    process.env.ACTOR_SERVICE + "client/" + id + "/popup-notes"
                )
                .then(function (response) {
                    self.notification.client = response.data.response.resource;
                });
        },
        async open(start, end, staff_id) {
            _.assign(this.$data, this.$options.data());
            _.assign(this.$data.client_data, this.$options.data().client_data);
            this.open_time = moment().tz(this._timeZone);
            this.page = "appointment";

            await this.getAppointmentData(start);
            this.$refs.checkInModal.show();
        },
        async save() {
            let self = this;
            let promise = true;
            let response = false;
            let isProvider = true;

            if (self.page == "appointment") {
                promise = await self.$refs.appointment.$validator.validateAll();
                isProvider = self.$refs.appointment.checkStaffIdInProviders();
            }
            if (self.page == "bundle") {
                promise = await self.$refs.bundle.$validator.validateAll();
            }

            if (promise && isProvider) {
                this.loading = true;
                const { response, admitResponse } = await this._saveCheckIn(
                    self.appointment_data,
                    self.bundle_data
                );
                if (response && response.state == 0) {
                    self.loading = false;
                    self.$refs.checkInModal.hide();
                    self.$parent.refetch();

                    if (response.action_response) {
                        self.handleActionResponse(
                            response,
                            (message, variant) => {
                                self._message(message, variant);
                            }
                        );
                    }

                    if (
                        response.disc_message !== undefined &&
                        response.disc_message !== "" &&
                        response.disc_message !== null
                    ) {
                        self._message(
                            response.message +
                                (self.appointment_data.admit
                                    ? " and admitted"
                                    : "") +
                                ". " +
                                response.disc_message
                        );
                    } else {
                        let message = response.message;

                        if (self.appointment_data.admit) {
                            message += " and admitted";
                        }

                        if (response.webform && response.webform.message) {
                            if (message.endsWith(".")) {
                                message += response.webform.message;
                            } else {
                                message += `. ${response.webform.message}`;
                            }
                        }
                        self._message(message);
                    }

                    if (
                        (response.lab_ids && response.lab_ids.length > 0) ||
                        response.idexx_lab_id
                    ) {
                        let print_lab_params = {
                            idexx_lab_id: response.idexx_lab_id,
                            idexx_url: response.idexx_url,
                            lab_ids: response.lab_ids,
                            source: response.lab_source,
                            module: "appointment"
                        };

                        self._print_lab_order(print_lab_params).then(function (
                            lab_response
                        ) {
                            if (lab_response.idexx_iframe) {
                                //load idexx iframe
                                lab_response.module_url =
                                    print_lab_params.module_url;
                                lab_response.module = print_lab_params.module;

                                self.$root.$emit(
                                    "call_idexx_iframe",
                                    lab_response
                                );
                            } else {
                                //load requisition form modal
                                lab_response.module_url =
                                    print_lab_params.module_url;
                                lab_response.module = print_lab_params.module;

                                self.$root.$emit(
                                    "call-multirequsition-modal",
                                    lab_response
                                );
                            }
                        });
                    }

                    // antech v6
                    if (response.accession_id && response.antech_token) {
                        self.$root.$emit("call-antech-iframe", {
                            antech_token: response.antech_token,
                            accession_id: response.accession_id
                        });
                    }

                    if (
                        this.page == "appointment" &&
                        this.isStartTreatment &&
                        admitResponse &&
                        admitResponse.data &&
                        admitResponse.data.response &&
                        admitResponse.data.response.message.code == 200 &&
                        admitResponse.data.response.resources
                    ) {
                        /* Update start_treatment_data
                        Construct data to pass on startTreatment component*/
                        this.createStartTreatmentObject(
                            response,
                            admitResponse.data.response.resources
                        );

                        this.$nextTick(() => {
                            this.$refs.startTreatment.open(
                                this.start_treatment_data
                            );
                        });
                    }

                    // Emit socket to refresh census
                    const payload = {
                        appointmentDate: self.appointment_data?.start.unix(),
                        appointmentId: self.appointment_data?.id,
                        instanceId: self.instanceId
                    };

                    self.refreshCensus(payload);
                } else {
                    self.loading = false;
                    self._message("Appointment save error", "danger");
                }
            } else {
                this.loading = false;
            }
            return response;
        },
        getAppointmentData(id) {
            let self = this;
            self.$emit("show-loading", true);
            return this.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment/" + id)
                .then(function (response) {
                    self.appointment_data = _.merge(
                        self.appointment_data,
                        response.data.response.resources
                    );
                    self.appointment_data.start = moment(
                        self.appointment_data.start
                    );
                    self.appointment_data.end = moment(
                        self.appointment_data.end
                    );
                    self.appointment_data.soap_id = null;
                    self.appointment_data.referrer = self._parseReferrer(
                        self.appointment_data.referral,
                        self.appointment_data.referralSubject
                    );
                    self.$nextTick(() => {
                        if (self.$refs.appointment) {
                            self.$refs.appointment.$validator.reset();
                        }
                    });
                })
                .finally(() => {
                    this.$emit("show-loading", false);
                });
        },
        async createStartTreatmentObject(response, admitResponse) {
            if (response && response.triage && admitResponse) {
                admitResponse.active_triage = response.triage;
            }

            this.start_treatment_data = {
                patient: admitResponse.patient,
                treatment: admitResponse, // Updated admitResponse with active_triage
                clientID: admitResponse.client_id,
                treatmentID: admitResponse.id
            };
        },
        next() {
            let self = this;
            if (self.page == "appointment") {
                self.$refs.appointment.$validator.validateAll().then(result => {
                    if (result) {
                        self.bundle_data.bundle_id =
                            self.appointment_data.bundle_id;

                        self.page = "bundle";
                        this.title = "New Bundle";

                        $(".modal-content").removeAttr("tabindex");
                    }
                });
            }
        },
        back() {
            if (this.page == "bundle") {
                this.page = "appointment";
                this.title = "Check In";
            }
        },
        close() {
            this.$socket.client.emit("v-broadcast-all", {
                action: "draft-remove"
            });
        }
    }
};
</script>
